import React, { useEffect, useState } from 'react';
import { DayPickerProps } from 'react-day-picker';

import { useBreakpoint } from '@/hooks/useBreakpoint';
import { ILocationSearchAutocompleteListOption } from '@/hooks/useLocationSearchAutocompleteOptions';

import { INavbarSearch } from '../../SearchHeader';
import { EVENT_OPEN_SEARCH_DATES } from '../events';
import MobileSearchMobileButton from './MobileSearchMobileButton';
import { MobileSearchModal } from './MobileSearchModal';

interface IMobileNavbarSearch extends INavbarSearch {
  onClose?: () => void;
  onOpen?: () => void;
  popularDestinations?: ILocationSearchAutocompleteListOption[];
  variant?: 'minimal' | 'enhanced';
  isGuestOccupancyAvailable?: boolean;
  scrollToSearchFilter?: () => void;
  disabledDays?: DayPickerProps['disabled'];
  isSERP?: boolean;
  redesigned?: boolean;
}

const MobileNavbarSearch: React.FC<IMobileNavbarSearch> = ({
  location,
  address,
  dates,
  guests,
  onSubmit,
  onChangeGuests,
  onChangeDates,
  onChangeAddress,
  popularDestinations,
  recentSearches,
  handleRecentSearchNavigation,
  variant,
  isGuestOccupancyAvailable,
  scrollToSearchFilter,
  disabledDays = [],
  isSERP,
  redesigned,
}) => {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const { isMobile } = useBreakpoint();

  useEffect(() => {
    if (!isMobile) return;
    const handleOnOpenSearchDates = () => {
      if (isSearchModalOpen) return;
      setTimeout(() => setIsSearchModalOpen(true), 100);
    };
    document.addEventListener(EVENT_OPEN_SEARCH_DATES, handleOnOpenSearchDates);
    return () => document.removeEventListener(EVENT_OPEN_SEARCH_DATES, handleOnOpenSearchDates);
  }, [isMobile, isSearchModalOpen]);

  return (
    <div>
      <MobileSearchMobileButton
        address={address}
        dates={dates}
        guests={guests}
        onOpenMobileSearch={() => setIsSearchModalOpen(true)}
        variant={variant}
        scrollToSearchFilter={scrollToSearchFilter}
        isSERP={isSERP}
        redesigned={redesigned}
      />
      <MobileSearchModal
        location={location}
        address={address}
        dates={dates}
        guests={guests}
        isSearchModalOpen={isSearchModalOpen}
        onCloseHandler={() => {
          setIsSearchModalOpen(false);
        }}
        onSubmit={onSubmit}
        onChangeGuests={onChangeGuests}
        onChangeDates={onChangeDates}
        onChangeAddress={onChangeAddress}
        popularDestinations={popularDestinations}
        recentSearches={recentSearches}
        handleRecentSearchNavigation={handleRecentSearchNavigation}
        isGuestOccupancyAvailable={isGuestOccupancyAvailable}
        hasVariant={!!variant}
        disabledDays={disabledDays}
      />
    </div>
  );
};

export default MobileNavbarSearch;
